'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fasdr';
var iconName = 'face-glasses';
var width = 576;
var height = 512;
var aliases = [];
var unicode = 'e377';
var svgPathData = ['M85.6 304C107.2 395.7 189.6 464 288 464s180.8-68.3 202.4-160l-162.4 0-6.4-4.8-32-24-1.6-1.2-1.6 1.2-32 24-6.4 4.8-162.4 0zM155.1 96l92.9 0 6.4 4.8 32 24 1.6 1.2c18-18 28-28 30-30l102.9 0c-36-30-82.4-48-132.9-48S191.1 66 155.1 96zm19.6 272.6c-9.2-9.6-8.9-24.8 .7-33.9s24.8-8.9 33.9 .7C224.3 351 250.4 368 288 368s63.7-17 78.7-32.6c9.2-9.6 24.4-9.9 33.9-.7s9.9 24.4 .7 33.9c-22.1 23-60 47.4-113.3 47.4s-91.2-24.4-113.3-47.4z', 'M328 96l92.9 0c-36-30-82.4-48-132.9-48S191.1 66 155.1 96l92.9 0 6.4 4.8 32 24 1.6 1.2c18-18 28-28 30-30l9.9 0zM288 274l-1.6 1.2-32 24-6.4 4.8-162.4 0C107.2 395.7 189.6 464 288 464s180.8-68.3 202.4-160l-162.4 0-6.4-4.8-32-24-1.6-1.2zM24 128l24 0 0-32 40.1 0C135.1 37.5 207.2 0 288 0S440.9 37.5 487.9 96l40.1 0 0 32 24 0 0 48-20.7 0c8.3 25.2 12.7 52.1 12.7 80 0 141.4-114.6 256-256 256S32 397.4 32 256c0-27.9 4.5-54.8 12.7-80l-20.7 0 0-48zm456 48l0-32-142.1 0-9.9 9.9 0 90.1 16 12 136 0 0-80zM209.3 335.4C224.3 351 250.4 368 288 368s63.7-17 78.7-32.6c9.2-9.6 24.4-9.9 33.9-.7s9.9 24.4 .7 33.9c-22.1 23-60 47.4-113.3 47.4s-91.2-24.4-113.3-47.4c-9.2-9.6-8.9-24.8 .7-33.9s24.8-8.9 33.9 .7zM160 208a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm224-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM96 256l136 0 16-12 0-88-16-12-136 0 0 112z'];

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faFaceGlasses = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;